import { render, staticRenderFns } from "./ObservationPaymentStatusAdditionalForm.vue?vue&type=template&id=d654dc38&scoped=true"
import script from "./ObservationPaymentStatusAdditionalForm.vue?vue&type=script&lang=js"
export * from "./ObservationPaymentStatusAdditionalForm.vue?vue&type=script&lang=js"
import style0 from "./ObservationPaymentStatusAdditionalForm.vue?vue&type=style&index=0&id=d654dc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d654dc38",
  null
  
)

export default component.exports